import { render, staticRenderFns } from "./TheRightPanel.vue?vue&type=template&id=bc71ffc4&"
import script from "./TheRightPanel.vue?vue&type=script&lang=ts&"
export * from "./TheRightPanel.vue?vue&type=script&lang=ts&"
import style0 from "./TheRightPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports